export default {
    data() {
        return {
            search: '',
            searchTimeout: -1,
            count: 535,
            isLoadingCompanyList: true,
            companies: [],
            page: 1,

            activeCompany: { id: -1, description: "Companies are Loading" },
            states: [
                'NSW',
                'QLD',
                'SA',
                'WA',
                'TAS',
                'VIC',
                'ACT',
                'NT'
            ],
        }
    },
    watch: {
        search(data) {
            if(this.searchTimeout !== -1) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.GET_INITIAL_COMPANIES_LIST(1, 10, data)
            }, 1000);
    },
    },
    computed: {
        pages() {
            return Math.ceil(this.count / 10);
        },
    },
    methods: {
        SET_PAGINATION(page) {
            this.page = page;
            this.GET_INITIAL_COMPANIES_LIST(page, 10);
        },
        async GET_INITIAL_COMPANIES_LIST(page = 1, limit = 10, search = '') {
            this.isLoadingCompanyList = true;
            const response = await this.$api.get(
                `Companies?offset=${page}&limit=${limit}&searchKey=${search}`
            );
            if (response.result === "OK" && response.message === "OK") {
                this.companies = response.data.items;
                this.count = response.data.count;
                if (this.$route.params.companyId) {
                    this.activeCompany = response.data.find(d => d.id === Number(this.$route.params.companyId))
                }
            }
            else this.companies = [];
            this.isLoadingCompanyList = false;
        },
    },
    mounted() {
        this.GET_INITIAL_COMPANIES_LIST();
    }
}